import { Link } from "react-router-dom";
import { BrandMark } from "@/features/admin/components/BrandMark";

export function NotFoundPage({
  title = "Nothing here",
  message = "This link doesn't point anywhere. Check the address, or head to the admin console.",
}: { title?: string; message?: string }) {
  return (
    <div className="grid min-h-full place-items-center bg-ink-850 px-6 py-16">
      <div className="flex max-w-sm flex-col items-center gap-5 text-center">
        <BrandMark size={48} />
        <div className="flex flex-col gap-2">
          <h1 className="text-xl font-semibold">{title}</h1>
          <p className="text-sm leading-relaxed text-haze-300">{message}</p>
        </div>
        <Link
          to="/admin"
          className="grid h-10 place-items-center rounded-lg border border-ink-500 px-5 text-sm text-haze-100 transition-colors hover:border-accent hover:text-accent"
        >
          Go to admin console
        </Link>
      </div>
    </div>
  );
}
